var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
import * as __au2ViewDef from './my-app.html';
import { ContactType } from './resources/models/contact-model';
import { SocialMediaType } from './resources/models/social-media-model';
import { log } from './resources/utilities/logger';
import { IRouter } from '@aurelia/router';
import { AuthenticatedRoutes } from './config/routes.config';
import { IPortalService } from './resources/services/portal-service';
import { IPartyService } from './resources/services/party-service';
import { IFetchConfig, IAuthService } from 'aurelia2-auth';
import { IAppService } from './resources/services/app-service';
import authConfig from './config/auth.config';
import { watch, customElement } from '@aurelia/runtime-html';
import environment from './environment';
let MyApp = class MyApp {
    api;
    partyApi;
    auth;
    fetchConfig;
    appService;
    router;
    static routes = AuthenticatedRoutes;
    // Pass routes to view
    routes = AuthenticatedRoutes;
    userProfile = {};
    adviserDetails = {};
    appClient;
    profileMenuLinks = [];
    showProfileMenu = false;
    constructor(api, partyApi, auth, fetchConfig, appService, router) {
        this.api = api;
        this.partyApi = partyApi;
        this.auth = auth;
        this.fetchConfig = fetchConfig;
        this.appService = appService;
        this.router = router;
        this.appClient = this.appService.appClient ?? environment.appClient;
        this.fetchConfig.configure();
    }
    attached() {
        window.addEventListener('click', this.clickHandler);
    }
    detached() {
        window.removeEventListener('click', this.clickHandler);
    }
    clickHandler = () => {
        const isShowing = document.getElementsByClassName('profile-menu-show');
        if (isShowing.length) {
            this.showProfileMenu = false;
        }
    };
    async binding() {
        try {
            this.userProfile = await this.api.getClientProfile();
            this.adviserDetails = await this.api.getAdviserDetails();
            const d = new Date();
            this.adviserDetails.currentYear = d.getFullYear();
            // prep the phone number(s)
            this.adviserDetails.phones = [];
            this.adviserDetails.adviserContact
                .filter((item) => item.contactType === ContactType.PhoneNumber)
                .map((phone) => {
                if (typeof this.adviserDetails.phones.find((x) => (x.phoneNumber = phone.phoneNumber)) ==
                    'undefined') {
                    this.adviserDetails.phones.push({
                        displayNumber: phone.telephoneNumber,
                    });
                }
            })
                .sort();
            // prep the email address
            const emailAddress = this.adviserDetails.adviserContact.find((item) => item.contactType === ContactType.EmailAddress);
            this.adviserDetails.adviserEmailAddress = emailAddress.email;
            // prep facebook link
            let socialMediaLink = this.adviserDetails.socialMedia.find((item) => item.socialMediaTypeStr === SocialMediaType.Facebook);
            this.adviserDetails.adviserFacebook = typeof socialMediaLink == 'undefined' ? '' : socialMediaLink.url;
            // prep twitter link
            socialMediaLink = this.adviserDetails.socialMedia.find((item) => item.socialMediaTypeStr === SocialMediaType.Twitter);
            this.adviserDetails.adviserTwitter = typeof socialMediaLink == 'undefined' ? '' : socialMediaLink.url;
            // prep linkedin link
            socialMediaLink = this.adviserDetails.socialMedia.find((item) => item.socialMediaTypeStr === SocialMediaType.LinkedIn);
            this.adviserDetails.adviserLinkedIn = typeof socialMediaLink == 'undefined' ? '' : socialMediaLink.url;
            this.buildProfileMenu();
        }
        catch (err) {
            log.error(err);
        }
    }
    onProfileItemClick(item) {
        if (item.path) {
            this.router.load(item.path);
            this.onCloseProfile();
        }
        else if (item.subLinks) {
            if (!item.showSubLinks) {
                this.closeSubMenus();
                item.showSubLinks = !item.showSubLinks;
            }
            else {
                item.showSubLinks = false;
            }
        }
        else if (item.logout) {
            this.auth.logout('/');
            sessionStorage.clear();
        }
    }
    buildProfileMenu() {
        this.profileMenuLinks = [
            { display: 'Manage Profile', path: `/profile/${this.userProfile.clientCode}` },
            { display: 'Logout', logout: true },
        ];
    }
    onProfileClick = (event) => {
        const item = this.clickInsideElement(event, 'profile-menu');
        if (item == false) {
            this.showProfileMenu = !this.showProfileMenu;
        }
    };
    onCloseProfile = () => {
        this.showProfileMenu = false;
        this.closeSubMenus();
    };
    closeSubMenus() {
        const openItem = this.profileMenuLinks.find((item) => item.showSubLinks);
        if (openItem != null) {
            openItem.showSubLinks = false;
        }
    }
    clickInsideElement(e, className) {
        if (e == null) {
            return false;
        }
        let el = e.srcElement || e.target;
        if (el?.classList?.contains(className)) {
            return el;
        }
        else {
            while ((el = el.parentNode)) {
                if (el.classList && el.classList.contains(className)) {
                    return el;
                }
            }
        }
        return false;
    }
    redirectOnNullToken(newToken) {
        if (!newToken) {
            this.router.load('/');
        }
    }
    get authTokenChanged() {
        const tokenName = authConfig.tokenPrefix
            ? `${authConfig.tokenPrefix}_${authConfig.tokenName}`
            : authConfig.tokenName;
        return sessionStorage.getItem(tokenName);
    }
};
__decorate([
    watch('authTokenChanged'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], MyApp.prototype, "redirectOnNullToken", null);
MyApp = __decorate([
    customElement(__au2ViewDef),
    __param(0, IPortalService),
    __param(1, IPartyService),
    __param(2, IAuthService),
    __param(3, IFetchConfig),
    __param(4, IAppService),
    __param(5, IRouter),
    __metadata("design:paramtypes", [Object, Object, Object, Object, Object, Object])
], MyApp);
export { MyApp };
import { Metadata as $$M } from '@aurelia/metadata';
import { CustomElement as $$CE, IHydrationContext as $$IHC } from '@aurelia/runtime-html';
// @ts-ignore
const controllers = [];
// @ts-ignore
if (module.hot) {
    // @ts-ignore
    module.hot.accept();
    // @ts-ignore
    const hot = module.hot;
    let aurelia = hot.data?.aurelia;
    // @ts-ignore
    document.addEventListener('au-started', (event) => { aurelia = event.detail; });
    const currentClassType = MyApp;
    // @ts-ignore
    const proto = MyApp.prototype;
    // @ts-ignore
    const ogCreated = proto ? proto.created : undefined;
    if (proto) {
        // @ts-ignore
        proto.created = function (controller) {
            // @ts-ignore
            ogCreated && ogCreated.call(this, controller);
            controllers.push(controller);
        };
    }
    // @ts-ignore
    hot.dispose(function (data) {
        // @ts-ignore
        data.controllers = controllers;
        data.aurelia = aurelia;
    });
    if (hot.data?.aurelia) {
        const newDefinition = $$CE.getDefinition(currentClassType);
        $$M.define(newDefinition.name, newDefinition, currentClassType);
        $$M.define(newDefinition.name, newDefinition, newDefinition);
        hot.data.aurelia.container.res[$$CE.keyFrom(newDefinition.name)] = newDefinition;
        const previousControllers = hot.data.controllers ?? [];
        if (previousControllers.length === 0) {
            // @ts-ignore
            hot.invalidate?.();
        }
        // @ts-ignore
        previousControllers.forEach(controller => {
            const values = { ...controller.viewModel };
            const hydrationContext = controller.container.get($$IHC);
            const hydrationInst = hydrationContext.instruction;
            const bindableNames = Object.keys(controller.definition.bindables);
            // @ts-ignore
            Object.keys(values).forEach(key => {
                if (bindableNames.includes(key)) {
                    return;
                }
                // if there' some bindings that target the existing property
                // @ts-ignore
                const isTargettedByBinding = controller.bindings?.some(y => y.ast?.$kind === 2 /* $$EK.AccessScope */
                    && y.ast.name === key && y.targetProperty);
                if (!isTargettedByBinding) {
                    delete values[key];
                }
            });
            const h = controller.host;
            delete controller._compiledDef;
            controller.viewModel = controller.container.invoke(currentClassType);
            controller.definition = newDefinition;
            Object.assign(controller.viewModel, values);
            if (controller._hydrateCustomElement) {
                controller._hydrateCustomElement(hydrationInst, hydrationContext);
            }
            else {
                controller.hE(hydrationInst, hydrationContext);
            }
            h.parentNode.replaceChild(controller.host, h);
            controller.hostController = null;
            controller.deactivate(controller, controller.parent ?? null, 0);
            controller.activate(controller, controller.parent ?? null, 0);
        });
    }
}
